/**
 * File generated by the TR Token Service.
 * Do not edit directly.
 * Generated on Tue, 04 Oct 2022 16:48:21 GMT
 */

export const COLORS_BACKGROUND_ACCORDION_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_ACCORDION_HOVER = '#fafafaff';
export const COLORS_BACKGROUND_ACCORDION_SELECTED = '#1f1f1fff';
export const COLORS_BACKGROUND_ALERT_ERROR = '#c20000ff';
export const COLORS_BACKGROUND_ALERT_ERROR_LIGHT = '#ffeaecff';
export const COLORS_BACKGROUND_ALERT_INFORMATION = '#00467bff';
export const COLORS_BACKGROUND_ALERT_INFORMATION_LIGHT = '#e1f5f8ff';
export const COLORS_BACKGROUND_ALERT_SUCCESS = '#387c2bff';
export const COLORS_BACKGROUND_ALERT_SUCCESS_LIGHT = '#e2eec6ff';
export const COLORS_BACKGROUND_ALERT_WARNING = '#993500ff';
export const COLORS_BACKGROUND_ALERT_WARNING_LIGHT = '#ffe9b0ff';
export const COLORS_BACKGROUND_BACK_TO_TOP_DEFAULT = '#fa6400ff';
export const COLORS_BACKGROUND_BACK_TO_TOP_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_BACK_TO_TOP_HOVER = '#dc4300ff';
export const COLORS_BACKGROUND_BACK_TO_TOP_PRESSED = '#dc4300ff';
export const COLORS_BACKGROUND_BUTTON_MENU_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_DEFAULT = '#fafafaff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_DISABLED = '#f7f7f7ff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_FOCUS = '#fafafaff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_HOVER = '#edededff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_LARGE_DEFAULT = '#fafafaff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_LARGE_DISABLED = '#f7f7f7ff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_LARGE_FOCUS = '#fafafaff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_LARGE_HOVER = '#edededff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_LARGE_PRESSED = '#edededff';
export const COLORS_BACKGROUND_BUTTON_CONTROL_PRESSED = '#edededff';
export const COLORS_BACKGROUND_BUTTON_GHOST_DEFAULT = '#ffffff00';
export const COLORS_BACKGROUND_BUTTON_GHOST_DISABLED = '#ffffff00';
export const COLORS_BACKGROUND_BUTTON_GHOST_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_BUTTON_GHOST_HOVER = '#f7f7f7ff';
export const COLORS_BACKGROUND_BUTTON_GHOST_PRESSED = '#f7f7f7ff';
export const COLORS_BACKGROUND_BUTTON_GHOST_SMALL_DEFAULT = '#ffffff00';
export const COLORS_BACKGROUND_BUTTON_GHOST_SMALL_DISABLED = '#ffffff00';
export const COLORS_BACKGROUND_BUTTON_GHOST_SMALL_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_BUTTON_GHOST_SMALL_HOVER = '#f7f7f7ff';
export const COLORS_BACKGROUND_BUTTON_GHOST_SMALL_PRESSED = '#f7f7f7ff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_DEFAULT = '#fa6400ff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_DISABLED = '#edededff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_FOCUS = '#993500ff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_HOVER = '#dc4300ff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_PRESSED = '#dc4300ff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_SMALL_DEFAULT = '#1f1f1fff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_SMALL_DISABLED = '#edededff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_SMALL_FOCUS = '#1f1f1fff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_SMALL_HOVER = '#404040ff';
export const COLORS_BACKGROUND_BUTTON_PRIMARY_SMALL_PRESSED = '#404040ff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_DISABLED = '#ffffffff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_FOCUS = '#1f1f1fff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_HOVER = '#404040ff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_PRESSED = '#404040ff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_SMALL_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_SMALL_DISABLED = '#ffffffff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_SMALL_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_SMALL_HOVER = '#dededeff';
export const COLORS_BACKGROUND_BUTTON_SECONDARY_SMALL_PRESSED = '#dededeff';
export const COLORS_BACKGROUND_CARD_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_CHECKMARK_DISABLED_SELECTED_INVERSE = '#9c9c9cff';
export const COLORS_BACKGROUND_CHECKBOX_CHECKMARK_ERROR_SELECTED_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_CHECKMARK_SELECTED = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_CHECKMARK_SELECTED_INVERSE = '#1f1f1fff';
export const COLORS_BACKGROUND_CHECKBOX_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_DISABLED = '#dededeff';
export const COLORS_BACKGROUND_CHECKBOX_DISABLED_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_CHECKBOX_DISABLED_SELECTED = '#9c9c9cff';
export const COLORS_BACKGROUND_CHECKBOX_DISABLED_SELECTED_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_CHECKBOX_ERROR = '#c20000ff';
export const COLORS_BACKGROUND_CHECKBOX_ERROR_DISABLED_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_CHECKBOX_ERROR_INVERSE = '#f84335ff';
export const COLORS_BACKGROUND_CHECKBOX_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_FOCUS_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_CHECKBOX_HOVER = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_HOVER_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_CHECKMARK_ERROR_SELECTED_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_CHECKMARK_SELECTED = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_CHECKMARK_SELECTED_INVERSE = '#1f1f1fff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_DISABLED = '#9c9c9cff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_ERROR = '#c20000ff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_ERROR_INVERSE = '#f84335ff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_FOCUS = '#1f1f1fff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_FOCUS_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_SELECTED = '#1f1f1fff';
export const COLORS_BACKGROUND_CHECKBOX_PARTIAL_SELECTED_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_SELECTED = '#1f1f1fff';
export const COLORS_BACKGROUND_CHECKBOX_SELECTED_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_CHECKBOX_UNSELECTED_ERROR = '#ffffffff';
export const COLORS_BACKGROUND_CHIP_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_CHIP_DISABLED = '#edededff';
export const COLORS_BACKGROUND_CHIP_FOCUS = '#f7f7f7ff';
export const COLORS_BACKGROUND_CHIP_HOVER = '#f7f7f7ff';
export const COLORS_BACKGROUND_CHIP_SELECTED = '#1f1f1fff';
export const COLORS_BACKGROUND_CONTENT_BRAND = '#fa6400ff';
export const COLORS_BACKGROUND_CONTENT_PRIMARY = '#ffffffff';
export const COLORS_BACKGROUND_CONTENT_QUATERNARY = '#fafafaff';
export const COLORS_BACKGROUND_CONTENT_SECONDARY = '#f7f7f7ff';
export const COLORS_BACKGROUND_CONTENT_TERTIARY = '#666666ff';
export const COLORS_BACKGROUND_DIVIDER_PRIMARY = '#d0d0d0ff';
export const COLORS_BACKGROUND_DIVIDER_SECONDARY = '#dededeff';
export const COLORS_BACKGROUND_FORM_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_FORM_DISABLED_DEFAULT = '#f7f7f7ff';
export const COLORS_BACKGROUND_FORM_SECONDARY_FOCUS = '#737373ff';
export const COLORS_BACKGROUND_ICON_DEFAULT = '#404040ff';
export const COLORS_BACKGROUND_INPUT_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_INPUT_DISABLED = '#f7f7f7ff';
export const COLORS_BACKGROUND_INPUT_ERROR = '#ffffffff';
export const COLORS_BACKGROUND_INPUT_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_INPUT_HOVER = '#ffffffff';
export const COLORS_BACKGROUND_INPUT_PHONE_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_INPUT_SELECTED = '#ffffffff';
export const COLORS_BACKGROUND_INPUT_SUCCESS = '#ffffffff';
export const COLORS_BACKGROUND_LINK_INVERSE_FOCUS = '#1f1f1fff';
export const COLORS_BACKGROUND_LINK_PRIMARY_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_LINK_SECONDARY_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_MENU_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_MODAL_BACK_LAYER = '#00000033';
export const COLORS_BACKGROUND_MODAL_CONTAINER = '#ffffffff';
export const COLORS_BACKGROUND_NAVIGATION_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_RADIO_CHECKMARK_DISABLED = '#9c9c9cff';
export const COLORS_BACKGROUND_RADIO_CHECKMARK_ERROR = '#c20000ff';
export const COLORS_BACKGROUND_RADIO_CHECKMARK_ERROR_INVERSE = '#f84335ff';
export const COLORS_BACKGROUND_RADIO_CHECKMARK_HOVER = '#edededff';
export const COLORS_BACKGROUND_RADIO_CHECKMARK_HOVER_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_RADIO_CHECKMARK_SELECTED = '#1f1f1fff';
export const COLORS_BACKGROUND_RADIO_CHECKMARK_SELECTED_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_RADIO_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_RADIO_DISABLED = '#dededeff';
export const COLORS_BACKGROUND_RADIO_DISABLED_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_RADIO_ERROR = '#ffffffff';
export const COLORS_BACKGROUND_RADIO_ERROR_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_RADIO_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_RADIO_FOCUS_INVERSE = '#404040ff';
export const COLORS_BACKGROUND_RADIO_HOVER = '#ffffffff';
export const COLORS_BACKGROUND_RADIO_SELECTED = '#ffffffff';
export const COLORS_BACKGROUND_RADIO_UNSELECTED_ERROR = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_ACTIVATED = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_ACTIVATED_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_ASSEMBLED = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_ASSEMBLED_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_DEFAULT_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_DISABLED = '#f7f7f7ff';
export const COLORS_BACKGROUND_SELECT_DISABLED_INVERSE = '#f7f7f7ff';
export const COLORS_BACKGROUND_SELECT_ERROR = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_ERROR_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_FOCUS = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_FOCUS_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_HOVER = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_HOVER_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_SELECTED = '#ffffffff';
export const COLORS_BACKGROUND_SELECT_SELECTED_INVERSE = '#ffffffff';
export const COLORS_BACKGROUND_TABLE_DEFAULT = '#ffffffff';
export const COLORS_BACKGROUND_TAB_ITEM_DEFAULT = '#ffffff00';
export const COLORS_BACKGROUND_TAB_ITEM_DISABLED = '#ffffffff';
export const COLORS_BACKGROUND_TAB_ITEM_HOVER = '#edededff';
export const COLORS_BACKGROUND_TAB_ITEM_SELECTED = '#fa6400ff';
export const COLORS_BACKGROUND_TAG_PRIMARY = '#e1f5f8ff';
export const COLORS_BACKGROUND_TAG_SECONDARY = '#eee7f6ff';
export const COLORS_BACKGROUND_TAG_TERTIARY = '#f3f8e8ff';
export const COLORS_BACKGROUND_TEXT_AREA_DEFAULT = '#ffffffff';
export const COLORS_BORDER_ACCORDION_OPEN = '#57c1d9ff';
export const COLORS_BORDER_BUTTON_MENU_DEFAULT = '#404040ff';
export const COLORS_BORDER_BUTTON_CONTROL_DEFAULT = '#dededeff';
export const COLORS_BORDER_BUTTON_SECONDARY_DEFAULT = '#404040ff';
export const COLORS_BORDER_BUTTON_SECONDARY_DISABLED = '#9c9c9cff';
export const COLORS_BORDER_BUTTON_SECONDARY_SMALL_DEFAULT = '#404040ff';
export const COLORS_BORDER_BUTTON_SECONDARY_SMALL_DISABLED = '#9c9c9cff';
export const COLORS_BORDER_CHECKBOX_DEFAULT = '#737373ff';
export const COLORS_BORDER_CHECKBOX_DEFAULT_INVERSE = '#dededeff';
export const COLORS_BORDER_CHECKBOX_DISABLED = '#9c9c9cff';
export const COLORS_BORDER_CHECKBOX_DISABLED_INVERSE = '#737373ff';
export const COLORS_BORDER_CHECKBOX_ERROR_DISABLED_INVERSE = '#f84335ff';
export const COLORS_BORDER_CHECKBOX_HOVER = '#404040ff';
export const COLORS_BORDER_CHECKBOX_HOVER_INVERSE = '#fafafaff';
export const COLORS_BORDER_CHECKBOX_UNSELECTED_ERROR = '#c20000ff';
export const COLORS_BORDER_CHIP_DEFAULT = '#dededeff';
export const COLORS_BORDER_CHIP_DISABLED = '#9c9c9cff';
export const COLORS_BORDER_CHIP_HOVER = '#404040ff';
export const COLORS_BORDER_CONTROL_DEFAULT = '#666666ff';
export const COLORS_BORDER_CONTROL_DISABLED = '#9c9c9cff';
export const COLORS_BORDER_CONTROL_ERROR = '#c20000ff';
export const COLORS_BORDER_CONTROL_SELECTED = '#fa6400ff';
export const COLORS_BORDER_FOCUS_DEFAULT = '#00467bff';
export const COLORS_BORDER_FOCUS_INVERSE = '#b3e4edff';
export const COLORS_BORDER_FOCUS_OUTLINE = '#ffffffff';
export const COLORS_BORDER_FORM_ACTIVE = '#666666ff';
export const COLORS_BORDER_FORM_DEFAULT = '#737373ff';
export const COLORS_BORDER_FORM_DISABLED = '#9c9c9cff';
export const COLORS_BORDER_FORM_ERROR = '#c20000ff';
export const COLORS_BORDER_FORM_INVERSE_ERROR = '#f84335ff';
export const COLORS_BORDER_FORM_INVERSE_SUCCESS = '#8cb637ff';
export const COLORS_BORDER_FORM_SUCCESS = '#638e24ff';
export const COLORS_BORDER_INPUT_DEFAULT = '#737373ff';
export const COLORS_BORDER_INPUT_DEFAULT_INVERSE = '#737373ff';
export const COLORS_BORDER_INPUT_DISABLED = '#9c9c9cff';
export const COLORS_BORDER_INPUT_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_BORDER_INPUT_ERROR = '#c20000ff';
export const COLORS_BORDER_INPUT_ERROR_INVERSE = '#f84335ff';
export const COLORS_BORDER_INPUT_HOVER = '#737373ff';
export const COLORS_BORDER_INPUT_HOVER_INVERSE = '#737373ff';
export const COLORS_BORDER_INPUT_PHONE_DEFAULT = '#737373ff';
export const COLORS_BORDER_INPUT_PHONE_DEFAULT_INVERSE = '#737373ff';
export const COLORS_BORDER_INPUT_SELECTED = '#737373ff';
export const COLORS_BORDER_INPUT_SELECTED_INVERSE = '#737373ff';
export const COLORS_BORDER_INPUT_SUCCESS = '#638e24ff';
export const COLORS_BORDER_INPUT_SUCCESS_INVERSE = '#8cb637ff';
export const COLORS_BORDER_RADIO_DEFAULT = '#737373ff';
export const COLORS_BORDER_RADIO_DEFAULT_INVERSE = '#dededeff';
export const COLORS_BORDER_RADIO_DISABLED = '#9c9c9cff';
export const COLORS_BORDER_RADIO_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_BORDER_RADIO_ERROR = '#c20000ff';
export const COLORS_BORDER_RADIO_ERROR_INVERSE = '#f84335ff';
export const COLORS_BORDER_RADIO_HOVER = '#404040ff';
export const COLORS_BORDER_RADIO_HOVER_INVERSE = '#fafafaff';
export const COLORS_BORDER_RADIO_SELECTED = '#404040ff';
export const COLORS_BORDER_RADIO_SELECTED_INVERSE = '#ffffffff';
export const COLORS_BORDER_RADIO_UNSELECTED_ERROR = '#c20000ff';
export const COLORS_BORDER_SELECT_DEFAULT = '#737373ff';
export const COLORS_BORDER_SELECT_DEFAULT_INVERSE = '#737373ff';
export const COLORS_BORDER_SELECT_HOVER = '#9c9c9cff';
export const COLORS_BORDER_SELECT_HOVER_INVERSE = '#9c9c9cff';
export const COLORS_BORDER_SELECT_SELECTED = '#c20000ff';
export const COLORS_BORDER_SELECT_SELECTED_INVERSE = '#f84335ff';
export const COLORS_BORDER_TABLE_DEFAULT = '#404040ff';
export const COLORS_BORDER_TAB_LIST_DEFAULT = '#d0d0d0ff';
export const COLORS_BORDER_TEXT_AREA_DEFAULT = '#737373ff';
export const COLORS_FONT_ACCORDION_LABEL_DEFAULT = '#ffffffff';
export const COLORS_FONT_ACCORDION_LABEL_OPEN = '#404040ff';
export const COLORS_FONT_BACK_TO_TOP_DEFAULT = '#ffffffff';
export const COLORS_FONT_BACK_TO_TOP_FOCUS = '#404040ff';
export const COLORS_FONT_BUTTON_CONTROL_LARGE_DEFAULT = '#404040ff';
export const COLORS_FONT_BUTTON_CONTROL_LARGE_DISABLED = '#d0d0d0ff';
export const COLORS_FONT_BUTTON_CONTROL_LARGE_FOCUS = '#404040ff';
export const COLORS_FONT_BUTTON_CONTROL_LARGE_HOVER = '#404040ff';
export const COLORS_FONT_BUTTON_CONTROL_LARGE_PRESSED = '#404040ff';
export const COLORS_FONT_BUTTON_CONTROL_SMALL_DEFAULT = '#404040ff';
export const COLORS_FONT_BUTTON_CONTROL_SMALL_DISABLED = '#d0d0d0ff';
export const COLORS_FONT_BUTTON_CONTROL_SMALL_FOCUS = '#404040ff';
export const COLORS_FONT_BUTTON_CONTROL_SMALL_HOVER = '#404040ff';
export const COLORS_FONT_BUTTON_CONTROL_SMALL_PRESSED = '#404040ff';
export const COLORS_FONT_BUTTON_GHOST_DEFAULT = '#404040ff';
export const COLORS_FONT_BUTTON_GHOST_DISABLED = '#9c9c9cff';
export const COLORS_FONT_BUTTON_GHOST_FOCUS = '#404040ff';
export const COLORS_FONT_BUTTON_GHOST_HOVER = '#404040ff';
export const COLORS_FONT_BUTTON_GHOST_PRESSED = '#404040ff';
export const COLORS_FONT_BUTTON_GHOST_SMALL_DEFAULT = '#404040ff';
export const COLORS_FONT_BUTTON_GHOST_SMALL_DISABLED = '#9c9c9cff';
export const COLORS_FONT_BUTTON_GHOST_SMALL_FOCUS = '#404040ff';
export const COLORS_FONT_BUTTON_GHOST_SMALL_HOVER = '#404040ff';
export const COLORS_FONT_BUTTON_GHOST_SMALL_PRESSED = '#404040ff';
export const COLORS_FONT_BUTTON_PRIMARY_DEFAULT = '#ffffffff';
export const COLORS_FONT_BUTTON_PRIMARY_DISABLED = '#9c9c9cff';
export const COLORS_FONT_BUTTON_PRIMARY_FOCUS = '#ffffffff';
export const COLORS_FONT_BUTTON_PRIMARY_HOVER = '#ffffffff';
export const COLORS_FONT_BUTTON_PRIMARY_PRESSED = '#ffffffff';
export const COLORS_FONT_BUTTON_PRIMARY_SMALL_DEFAULT = '#ffffffff';
export const COLORS_FONT_BUTTON_PRIMARY_SMALL_DISABLED = '#9c9c9cff';
export const COLORS_FONT_BUTTON_PRIMARY_SMALL_FOCUS = '#ffffffff';
export const COLORS_FONT_BUTTON_PRIMARY_SMALL_HOVER = '#ffffffff';
export const COLORS_FONT_BUTTON_PRIMARY_SMALL_PRESSED = '#ffffffff';
export const COLORS_FONT_BUTTON_SECONDARY_DEFAULT = '#404040ff';
export const COLORS_FONT_BUTTON_SECONDARY_DISABLED = '#9c9c9cff';
export const COLORS_FONT_BUTTON_SECONDARY_FOCUS = '#ffffffff';
export const COLORS_FONT_BUTTON_SECONDARY_HOVER = '#ffffffff';
export const COLORS_FONT_BUTTON_SECONDARY_PRESSED = '#ffffffff';
export const COLORS_FONT_BUTTON_SECONDARY_SMALL_DEFAULT = '#404040ff';
export const COLORS_FONT_BUTTON_SECONDARY_SMALL_DISABLED = '#9c9c9cff';
export const COLORS_FONT_BUTTON_SECONDARY_SMALL_FOCUS = '#404040ff';
export const COLORS_FONT_BUTTON_SECONDARY_SMALL_HOVER = '#404040ff';
export const COLORS_FONT_BUTTON_SECONDARY_SMALL_PRESSED = '#404040ff';
export const COLORS_FONT_CARD_TEXT_PRIMARY = '#404040ff';
export const COLORS_FONT_CARD_TEXT_SECONDARY = '#666666ff';
export const COLORS_FONT_CARD_TEXT_TERTIARY = '#d0d0d0ff';
export const COLORS_FONT_CHECKBOX_EXTRA_INFO = '#9c9c9cff';
export const COLORS_FONT_CHECKBOX_EXTRA_INFO_INVERSE = '#9c9c9cff';
export const COLORS_FONT_CHECKBOX_LABEL_DEFAULT = '#404040ff';
export const COLORS_FONT_CHECKBOX_LABEL_DEFAULT_INVERSE = '#ffffffff';
export const COLORS_FONT_CHECKBOX_LABEL_DISABLED = '#9c9c9cff';
export const COLORS_FONT_CHECKBOX_LABEL_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_FONT_CHECKBOX_TITLE = '#1f1f1fff';
export const COLORS_FONT_CHECKBOX_TITLE_INVERSE = '#ffffffff';
export const COLORS_FONT_CHIP_DEFAULT = '#404040ff';
export const COLORS_FONT_CHIP_DISABLED = '#9c9c9cff';
export const COLORS_FONT_CHIP_HOVER = '#404040ff';
export const COLORS_FONT_CHIP_SELECTED = '#ffffffff';
export const COLORS_FONT_FORM_ICON_DEFAULT = '#404040ff';
export const COLORS_FONT_FORM_ICON_ERROR_DEFAULT = '#c20000ff';
export const COLORS_FONT_FORM_ICON_ERROR_INVERSE = '#f84335ff';
export const COLORS_FONT_FORM_ICON_SUCCESS_DEFAULT = '#638e24ff';
export const COLORS_FONT_FORM_ICON_SUCCESS_INVERSE = '#8cb637ff';
export const COLORS_FONT_FORM_MESSAGE_DEFAULT = '#404040ff';
export const COLORS_FONT_FORM_MESSAGE_DISABLED = '#9c9c9cff';
export const COLORS_FONT_FORM_MESSAGE_ERROR = '#c20000ff';
export const COLORS_FONT_FORM_MESSAGE_INVERSE_DEFAULT = '#ffffffff';
export const COLORS_FONT_FORM_MESSAGE_INVERSE_ERROR = '#f84335ff';
export const COLORS_FONT_FORM_MESSAGE_INVERSE_SUCCESS = '#8cb637ff';
export const COLORS_FONT_FORM_MESSAGE_SUCCESS = '#638e24ff';
export const COLORS_FONT_FORM_DISABLED = '#9c9c9cff';
export const COLORS_FONT_FORM_PLACEHOLDER_DEFAULT = '#737373ff';
export const COLORS_FONT_INPUT_EXTRA_INFO_DEFAULT = '#666666ff';
export const COLORS_FONT_INPUT_EXTRA_INFO_DEFAULT_INVERSE = '#9c9c9cff';
export const COLORS_FONT_INPUT_EXTRA_INFO_DISABLED = '#9c9c9cff';
export const COLORS_FONT_INPUT_EXTRA_INFO_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_FONT_INPUT_LABEL_DEFAULT = '#404040ff';
export const COLORS_FONT_INPUT_LABEL_DEFAULT_INVERSE = '#ffffffff';
export const COLORS_FONT_INPUT_LABEL_DISABLED = '#9c9c9cff';
export const COLORS_FONT_INPUT_LABEL_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_FONT_INPUT_PLACEHOLDER_DEFAULT = '#9c9c9cff';
export const COLORS_FONT_INPUT_PLACEHOLDER_DEFAULT_INVERSE = '#9c9c9cff';
export const COLORS_FONT_INPUT_PLACEHOLDER_DISABLED = '#9c9c9cff';
export const COLORS_FONT_INPUT_PLACEHOLDER_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_FONT_LABEL_DEFAULT = '#404040ff';
export const COLORS_FONT_LABEL_DISABLED = '#9c9c9cff';
export const COLORS_FONT_LABEL_INVERSE = '#ffffffff';
export const COLORS_FONT_LINK_BREADCRUMBS_DEFAULT = '#666666ff';
export const COLORS_FONT_LINK_BREADCRUMBS_HOVER = '#00467bff';
export const COLORS_FONT_LINK_BREADCRUMBS_VISITED = '#666666ff';
export const COLORS_FONT_LINK_HOVER = '#00467bff';
export const COLORS_FONT_LINK_INVERSE = '#ffffffff';
export const COLORS_FONT_LINK_INVERSE_HOVER = '#57c1d9ff';
export const COLORS_FONT_LINK_INVERSE_VISITED = '#d0d0d0ff';
export const COLORS_FONT_LINK_PRIMARY = '#005da2ff';
export const COLORS_FONT_LINK_SECONDARY = '#404040ff';
export const COLORS_FONT_LINK_SECONDARY_HOVER = '#00467bff';
export const COLORS_FONT_LINK_SECONDARY_VISITED = '#666666ff';
export const COLORS_FONT_LINK_VISITED = '#6e3ab7ff';
export const COLORS_FONT_MESSAGING_DEFAULT = '#404040ff';
export const COLORS_FONT_MODAL_TITLE = '#404040ff';
export const COLORS_FONT_RADIO_EXTRA_INFO = '#9c9c9cff';
export const COLORS_FONT_RADIO_EXTRA_INFO_INVERSE = '#9c9c9cff';
export const COLORS_FONT_RADIO_LABEL_DEFAULT = '#404040ff';
export const COLORS_FONT_RADIO_LABEL_DEFAULT_INVERSE = '#ffffffff';
export const COLORS_FONT_RADIO_LABEL_DISABLED = '#9c9c9cff';
export const COLORS_FONT_RADIO_LABEL_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_FONT_RADIO_TITLE = '#1f1f1fff';
export const COLORS_FONT_RADIO_TITLE_INVERSE = '#ffffffff';
export const COLORS_FONT_SELECT_EXTRA_INFO_DEFAULT = '#666666ff';
export const COLORS_FONT_SELECT_EXTRA_INFO_DEFAULT_INVERSE = '#9c9c9cff';
export const COLORS_FONT_SELECT_EXTRA_INFO_DISABLED = '#9c9c9cff';
export const COLORS_FONT_SELECT_EXTRA_INFO_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_FONT_SELECT_LABEL_DEFAULT = '#404040ff';
export const COLORS_FONT_SELECT_LABEL_DEFAULT_INVERSE = '#ffffffff';
export const COLORS_FONT_SELECT_LABEL_DISABLED = '#9c9c9cff';
export const COLORS_FONT_SELECT_LABEL_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_FONT_SELECT_PLACEHOLDER_DEFAULT = '#9c9c9cff';
export const COLORS_FONT_SELECT_PLACEHOLDER_DEFAULT_INVERSE = '#9c9c9cff';
export const COLORS_FONT_SELECT_PLACEHOLDER_DISABLED = '#9c9c9cff';
export const COLORS_FONT_SELECT_PLACEHOLDER_DISABLED_INVERSE = '#9c9c9cff';
export const COLORS_FONT_TAB_ITEM_DEFAULT = '#404040ff';
export const COLORS_FONT_TAB_ITEM_DISABLED = '#9c9c9cff';
export const COLORS_FONT_TAB_ITEM_HOVER = '#1f1f1fff';
export const COLORS_FONT_TAB_ITEM_SELECTED = '#ffffffff';
export const COLORS_FONT_TABLE_DEFAULT = '#404040ff';
export const COLORS_FONT_TAG_PRIMARY = '#00467bff';
export const COLORS_FONT_TAG_SECONDARY = '#3a1a92ff';
export const COLORS_FONT_TAG_TERTIARY = '#387c2bff';
export const COLORS_FONT_TEXT_AREA_EXTRA_INFO = '#404040ff';
export const COLORS_FONT_TEXT_AREA_LABEL = '#1f1f1fff';
export const COLORS_FONT_TEXT_AREA_PLACEHOLDER = '#737373ff';
export const COLORS_FONT_TEXT_BRAND = '#fa6400ff';
export const COLORS_FONT_TEXT_INVERSE = '#ffffffff';
export const COLORS_FONT_TEXT_PRIMARY = '#404040ff';
export const COLORS_FONT_TEXT_SECONDARY = '#666666ff';
export const COLORS_FONT_TEXT_TERTIARY = '#d0d0d0ff';
export const COLORS_FONT_TOAST_DEFAULT = '#404040ff';
export const EFFECTS_BORDER_RADIUS_BUTTON_DEFAULT = '100px';
export const EFFECTS_BORDER_RADIUS_MEDIUM = '8px';
export const EFFECTS_BORDER_RADIUS_PRICE_RANGE = '100px';
export const EFFECTS_BORDER_RADIUS_SMALL = '4px';
export const EFFECTS_BORDER_RADIUS_STICKY_NAV_POPUP_TRIANGLE_DEFAULT = '2px';
export const EFFECTS_BORDER_STYLE_BUTTON_CIRCULAR_DEFAULT = 'solid';
export const EFFECTS_BORDER_STYLE_BUTTON_CIRCULAR_DISABLED = 'none';
export const EFFECTS_BORDER_STYLE_BUTTON_SECONDARY_DEFAULT = 'solid';
export const EFFECTS_BORDER_STYLE_CARD_DEFAULT = 'none';
export const EFFECTS_BORDER_STYLE_CARD_FOCUS = 'solid';
export const EFFECTS_BORDER_STYLE_NONE = 'none';
export const EFFECTS_BORDER_STYLE_SOLID = 'solid';
export const EFFECTS_BORDER_WIDTH_BUTTON_DEFAULT = '1px';
export const EFFECTS_BORDER_WIDTH_CARD_FOCUS = '2px';
export const EFFECTS_BORDER_WIDTH_FORM_DEFAULT = '1px';
export const EFFECTS_BORDER_WIDTH_FORM_HIGHLIGHT = '2px';
export const EFFECTS_BORDER_WIDTH_NAV_OPTION_SELECTED = '4px';
export const EFFECTS_BORDER_WIDTH_ONE = '1px';
export const EFFECTS_BORDER_WIDTH_RADIO_CHECKBOX = '2px';
export const EFFECTS_BORDER_WIDTH_TABLE = '1px';
export const EFFECTS_BORDER_WIDTH_TABLE_HEADER = '2px';
export const EFFECTS_DROP_SHADOW_ACCESSIBILITY_ERROR = '0px 0px 4px 2px #f8948dff';
export const EFFECTS_DROP_SHADOW_ACCESSIBILITY_FOCUS = '0px 0px 2px 4px #00467bff';
export const EFFECTS_DROP_SHADOW_ACCESSIBILITY_FOCUS_DEFAULT = '0px 0px 2px 4px #00467bff';
export const EFFECTS_DROP_SHADOW_ACCESSIBILITY_FOCUS_INVERSE = '0px 0px 2px 4px #b3e4edff';
export const EFFECTS_DROP_SHADOW_ACCORDION_DEFAULT = '0px 4px 12px #1f1f1f14';
export const EFFECTS_DROP_SHADOW_BUTTON_FOCUS = '0px 0px 2px 4px #00467bff';
export const EFFECTS_DROP_SHADOW_BUTTON_HOVER = '0px 4px 6px #1f1f1f29';
export const EFFECTS_DROP_SHADOW_CARD_DEFAULT = '0px 4px 12px #1f1f1f14';
export const EFFECTS_DROP_SHADOW_CARD_DEFAULT_HOVER = '0px 8px 16px #00467b9e';
export const EFFECTS_DROP_SHADOW_CARD_FOCUS = '0px 4px 12px #1f1f1f14';
export const EFFECTS_DROP_SHADOW_CARD_GHOST_HOVER = '0px 4px 12px #1f1f1f14';
export const EFFECTS_DROP_SHADOW_FORM_SELECTED = '0px 4px 6px #00467b29';
export const EFFECTS_DROP_SHADOW_MEDIA_DEFAULT = '0px 20px 60px #9935001f';
export const EFFECTS_DROP_SHADOW_NAV_DEFAULT = '0px 4px 12px #1f1f1f14';
export const EFFECTS_DROP_SHADOW_SHARE_ICON_FOCUS = '0px 0px 2px 4px #00467bff';
export const EFFECTS_DROP_SHADOW_SHARE_ICON_HOVER = '0px 4px 6px #1f1f1f29';
export const EFFECTS_INNER_SHADOW_BUTTON_PRESSED = 'inset 0px 4px 8px #1f1f1f3d';
export const EFFECTS_INNER_SHADOW_GLOBAL_NAV_SECTION_2ND_LEVEL = 'inset 20px 0px 20px -20px #00000029';
export const EFFECTS_INNER_SHADOW_SHARE_ICON_PRESSED = 'inset 0px 4px 8px #1f1f1f3d';
export const EFFECTS_OUTLINE_STYLE_ACCESSIBILITY_FOCUS = 'solid';
export const EFFECTS_OUTLINE_WIDTH_ACCESSIBILITY_FOCUS = '2px';
export const EFFECTS_TRANSITION_TIMING_FADE_IN = 'cubic-bezier(0.44, 0, 0.56, 1)';
export const EFFECTS_TRANSITION_SPEED_BUTTON_HOVER = '200ms';
export const EFFECTS_TRANSITION_SPEED_COLOR_CHANGE = '200ms';
export const EFFECTS_TRANSITION_SPEED_FADE_IN = '100ms';
export const EFFECTS_TRANSITION_SPEED_ONE = '0.3s';
export const BREAKPOINT_DESKTOP = 1024;
export const BREAKPOINT_MOBILE = 0;
export const BREAKPOINT_TABLET = 600;
export const LAYOUT_COLUMNS_DESKTOP = 12;
export const LAYOUT_COLUMNS_MOBILE = 4;
export const LAYOUT_COLUMNS_TABLET = 12;
export const LAYOUT_GUTTER_DESKTOP = '24px';
export const LAYOUT_GUTTER_MOBILE = '16px';
export const LAYOUT_GUTTER_TABLET = '24px';
export const LAYOUT_MARGIN_DESKTOP = '60px';
export const LAYOUT_MARGIN_MOBILE = '20px';
export const LAYOUT_MARGIN_TABLET = '24px';
export const LAYOUT_MAX_WIDTH_DESKTOP = '1440px';
export const SPACING_COLUM_GAP_NAV_OPTION_WITH_ICON = '12px';
export const SPACING_COLUMN_GAP_FORM_ICON = '8px';
export const SPACING_COLUMN_GAP_GLOBAL_NAV_LINK_HEADER = '8px';
export const SPACING_COLUMN_GAP_PRICE_RANGE_CIRCLE = '4px';
export const SPACING_COLUMN_GAP_STICKY_NAV_CTA_DROPDOWN = '16px';
export const SPACING_COLUMN_GAP_STICKY_NAV_CTA_LINKS = '24px';
export const SPACING_COLUMN_GAP_STICKY_NAV_HEADER_DEFAULT = '16px';
export const SPACING_COLUMN_GAP_STICKY_NAV_LINK_LINKS = '32px';
export const SPACING_COLUMN_GAP_TAB_ITEM = '8px';
export const SPACING_HEIGHT_BUTTON_CIRCULAR_LARGE = '60px';
export const SPACING_HEIGHT_BUTTON_CIRCULAR_SMALL = '32px';
export const SPACING_HEIGHT_BUTTON_LARGE = '48px';
export const SPACING_HEIGHT_BUTTON_MEDIUM = '40px';
export const SPACING_HEIGHT_BUTTON_SMALL = '32px';
export const SPACING_HEIGHT_CHIP = '32px';
export const SPACING_HEIGHT_FORM_DEFAULT = '48px';
export const SPACING_HEIGHT_RADIO_CHECKBOX = '16px';
export const SPACING_HEIGHT_SCROLL_PROGRESS = '4px';
export const SPACING_HEIGHT_STICKY_NAV_DESKTOP = '72px';
export const SPACING_HEIGHT_STICKY_NAV_MOBILE = '56px';
export const SPACING_HEIGHT_TAB_ITEM_DEFAULT = '40px';
export const SPACING_LEFT_PADDING_CHECKBOX_GROUP_PARTIAL_CHILDREN = '16px';
export const SPACING_LEFT_STICKY_NAV_POPUP_TRIANGLE_DROPDOWN = '24px';
export const SPACING_LEFT_STICKY_NAV_POPUP_DROPDOWN = '12px';
export const SPACING_MARGIN_BOTTOM_BODY_LARGE = '24px';
export const SPACING_MARGIN_BOTTOM_BODY_MEDIUM = '24px';
export const SPACING_MARGIN_BOTTOM_BODY_SMALL = '24px';
export const SPACING_MARGIN_BOTTOM_FORM_LABEL = '8px';
export const SPACING_MARGIN_BOTTOM_HEADLINE_LARGE = '24px';
export const SPACING_MARGIN_BOTTOM_HEADLINE_MEDIUM = '20px';
export const SPACING_MARGIN_BOTTOM_HEADLINE_SMALL = '20px';
export const SPACING_MARGIN_BOTTOM_HEADLINE_XLARGE = '32px';
export const SPACING_MARGIN_BOTTOM_SUBTITLE = '16px';
export const SPACING_MARGIN_LEFT_BULLET_LIST_BODY_LARGE = '8px';
export const SPACING_MARGIN_LEFT_BULLET_LIST_BODY_MEDIUM = '8px';
export const SPACING_MARGIN_LEFT_BULLET_LIST_BODY_SMALL = '8px';
export const SPACING_MARGIN_LEFT_NUMBER_LIST_BODY_LARGE = '8px';
export const SPACING_MARGIN_LEFT_NUMBER_LIST_BODY_MEDIUM = '8px';
export const SPACING_MARGIN_LEFT_NUMBER_LIST_BODY_SMALL = '8px';
export const SPACING_MARGIN_TOP_BODY_LARGE = '24px';
export const SPACING_MARGIN_TOP_BODY_MEDIUM = '24px';
export const SPACING_MARGIN_TOP_BODY_SMALL = '24px';
export const SPACING_MARGIN_TOP_BULLET_LIST_ITEM_BODY_LARGE = '12px';
export const SPACING_MARGIN_TOP_BULLET_LIST_ITEM_BODY_MEDIUM = '12px';
export const SPACING_MARGIN_TOP_BULLET_LIST_ITEM_BODY_SMALL = '12px';
export const SPACING_MARGIN_TOP_HEADLINE_LARGE = '20px';
export const SPACING_MARGIN_TOP_HEADLINE_MEDIUM = '16px';
export const SPACING_MARGIN_TOP_HEADLINE_SMALL = '16px';
export const SPACING_MARGIN_TOP_HEADLINE_XLARGE = '20px';
export const SPACING_MARGIN_TOP_NUMBER_LIST_ITEM_BODY_LARGE = '12px';
export const SPACING_MARGIN_TOP_NUMBER_LIST_ITEM_BODY_MEDIUM = '12px';
export const SPACING_MARGIN_TOP_NUMBER_LIST_ITEM_BODY_SMALL = '12px';
export const SPACING_MARGIN_TOP_STICKY_NAV_POPUP_DEFAULT = '4px';
export const SPACING_MARGIN_TOP_SUBTITLE = '12px';
export const SPACING_MARGIN_BREADCRUMBS_DIVIDERS_LEFT_RIGHT = '8px';
export const SPACING_MAX_HEIGHT_MEDIA_CARD_DESKTOP = '240px';
export const SPACING_MAX_HEIGHT_MEDIA_CARD_MOBILE = '180px';
export const SPACING_MAX_HEIGHT_MEDIA_CARD_TABLET = '180px';
export const SPACING_MAX_HEIGHT_TEXTAREA_DEFAULT = '240px';
export const SPACING_MAX_WIDTH_GLOBAL_NAV_SECTION_DEFAULT = '260px';
export const SPACING_MAX_WIDTH_MODAL_CONTAINER = '720px';
export const SPACING_MAX_WIDTH_STICKY_NAV_DROPDOWN = '356px';
export const SPACING_MAX_WIDTH_CARD_LANDSCAPE = '1080px';
export const SPACING_MIN_HEIGHT_MODAL_CONTAINER = '260px';
export const SPACING_MIN_HEIGHT_TEXTAREA_DEFAULT = '92px';
export const SPACING_MIN_WIDTH_CARD_DEFAULT = '320px';
export const SPACING_MIN_WIDTH_CARD_DESKTOP = '208px';
export const SPACING_MIN_WIDTH_CARD_LANDSCAPE = '720px';
export const SPACING_MIN_WIDTH_CARD_MOBILE = '136px';
export const SPACING_MIN_WIDTH_GLOBAL_NAV_SECTION_DEFAULT = '240px';
export const SPACING_MIN_WIDTH_STICKY_NAV_DROPDOWN = '260px';
export const SPACING_PADDING_BOTTOM_RADIO_CHECKBOX = '8px';
export const SPACING_PADDING_BOTTOM_STICKY_NAV_TITLE_MOBILE = '4px';
export const SPACING_PADDING_LEFT_BULLET_LIST_BODY_LARGE = '12px';
export const SPACING_PADDING_LEFT_BULLET_LIST_BODY_MEDIUM = '12px';
export const SPACING_PADDING_LEFT_BULLET_LIST_BODY_SMALL = '12px';
export const SPACING_PADDING_LEFT_CHIP_ICON = '4px';
export const SPACING_PADDING_LEFT_NUMBER_LIST_BODY_LARGE = '12px';
export const SPACING_PADDING_LEFT_NUMBER_LIST_BODY_MEDIUM = '12px';
export const SPACING_PADDING_LEFT_NUMBER_LIST_BODY_SMALL = '12px';
export const SPACING_PADDING_LEFT_RADIO_CHECKBOX = '8px';
export const SPACING_PADDING_RIGHT_LEFT_CHIP = '12px';
export const SPACING_PADDING_RIGHT_LEFT_NAV_OPTION_DEFAULT = '20px';
export const SPACING_PADDING_RIGHT_LEFT_STICKY_NAV_DROPDOWN_DROPDOWN = '16px';
export const SPACING_PADDING_RIGHT_LEFT_TABLE_CELL_DEFAULT = '16px';
export const SPACING_PADDING_RIGHT_LEFT_TABLE_CELL_RELAXED = '16px';
export const SPACING_PADDING_RIGHT_RADIO_CHECKBOX_GROUP_OPTION = '24px';
export const SPACING_PADDING_TOP_BOTTOM_CHIP = '4px';
export const SPACING_PADDING_TOP_BOTTOM_GLOBAL_NAV_LINK_MOBILE = '12px';
export const SPACING_PADDING_TOP_BOTTOM_GLOBAL_NAV_SECTION_DIVIDER_DESKTOP = '8px';
export const SPACING_PADDING_TOP_BOTTOM_MODAL_BACK_LAYER = '24px';
export const SPACING_PADDING_TOP_BOTTOM_NAV_OPTION_DEFAULT = '12px';
export const SPACING_PADDING_TOP_BOTTOM_STICKY_NAV_DROPDOWN_DROPDOWN = '12px';
export const SPACING_PADDING_TOP_BOTTOM_STICKY_NAV_POPUP_DEFAULT = '16px';
export const SPACING_PADDING_ACCORDION_PANEL_LEFT_RIGHT = '16px';
export const SPACING_PADDING_ACCORDION_PANEL_TOP_DOWN = '24px';
export const SPACING_PADDING_BUTTON_ICON_LEFT_RIGHT = '8px';
export const SPACING_PADDING_BUTTON_LARGE_LEFT_RIGHT = '32px';
export const SPACING_PADDING_BUTTON_MEDIUM_LEFT_RIGHT = '24px';
export const SPACING_PADDING_BUTTON_SMALL_LEFT_RIGHT = '16px';
export const SPACING_PADDING_BUTTON_TOP_BOTTOM = '8px';
export const SPACING_PADDING_CARD_CONTENT_DEFAULT = '24px';
export const SPACING_PADDING_DROP_DOWN_DEFAULT = '16px';
export const SPACING_PADDING_FORM_DEFAULT = '16px';
export const SPACING_PADDING_GLOBAL_NAV_SECTION_TOP_BOTTOM = '24px';
export const SPACING_PADDING_MODAL_CONTENT = '24px';
export const SPACING_PADDING_MODAL_FOOTER_LEFT_RIGHT = '24px';
export const SPACING_PADDING_MODAL_FOOTER_TOP_BOTTOM = '16px';
export const SPACING_PADDING_MODAL_HEADER = '24px';
export const SPACING_PADDING_PAPER_DESKTOP = '60px';
export const SPACING_PADDING_PAPER_MOBILE = '40px';
export const SPACING_PADDING_PRODUCT_CARD_BOTTOM = '60px';
export const SPACING_PADDING_PRODUCT_CARD_LEFT_RIGHT = '32px';
export const SPACING_PADDING_PRODUCT_CARD_TOP = '48px';
export const SPACING_PADDING_RADIO_CHECKBOX_GROUP_MESSAGE_BOTTOM = '20px';
export const SPACING_PADDING_RADIO_CHECKBOX_GROUP_MESSAGE_TOP = '8px';
export const SPACING_PADDING_RADIO_CHECKBOX_GROUP_TITLE_BOTTOM = '16px';
export const SPACING_PADDING_ROTATOR_CONTROLLER_LABEL_LEFT_RIGHT = '16px';
export const SPACING_PADDING_SHARE_ICON_DEFAULT = '16px';
export const SPACING_PADDING_TAB_DEFAULT = '4px';
export const SPACING_PADDING_TAG_DEFAULT = '8px';
export const SPACING_PADDING_VIDEO_CARD_DEFAULT = '32px';
export const SPACING_RATIO_LANDSCAPE_LARGE = 2.45;
export const SPACING_RATIO_LANDSCAPE_MEDIUM = 1.7778;
export const SPACING_RATIO_LANDSCAPE_SMALL = 1.5;
export const SPACING_RATIO_PORTRAIT_LARGE = 0.75;
export const SPACING_RATIO_PORTRAIT_SMALL = 0.91;
export const SPACING_RATIO_SQUARE = 1;
export const SPACING_ROW_GAP_FORM_GROUP_ITEM_VERTICAL = '16px';
export const SPACING_ROW_GAP_GLOBAL_NAV_SECTION_MOBILE = '24px';
export const SPACING_SIZE_BACK_TO_TOP_DEFAULT = '40px';
export const SPACING_SIZE_GLOBAL_NAV_LINK_ICON_HEADER = '12px';
export const SPACING_SIZE_ICON_LARGE = '24px';
export const SPACING_SIZE_ICON_LOADER = '48px';
export const SPACING_SIZE_ICON_MEDIUM = '20px';
export const SPACING_SIZE_ICON_SMALL = '16px';
export const SPACING_SIZE_ICON_XSMALL = '12px';
export const SPACING_SIZE_LARGE = '32px';
export const SPACING_SIZE_MEDIUM = '20px';
export const SPACING_SIZE_PRICE_RANGE_CIRCLE = '12px';
export const SPACING_SIZE_SMALL = '12px';
export const SPACING_SIZE_STICKY_NAV_POPUP_TRIANGLE_DEFAULT = '16px';
export const SPACING_SIZE_XLARGE = '48px';
export const SPACING_SIZE_XSMALL = '8px';
export const SPACING_SIZE_XXLARGE = '84px';
export const SPACING_SIZE_XXSMALL = '4px';
export const SPACING_TEXT_INDENT_BODY_LARGE_DEFAULT = '0';
export const SPACING_TEXT_INDENT_BODY_MEDIUM_DEFAULT = '0';
export const SPACING_TEXT_INDENT_BODY_SMALL_DEFAULT = '0';
export const SPACING_WIDTH_CARD_MEDIA_LANDSCAPE = '252px';
export const SPACING_WIDTH_FORM_BEFORE_AFTER = '48px';
export const SPACING_WIDTH_RADIO_CHECKBOX = '16px';
export const SPACING_WIDTH_ROTATOR_CONTROLS = '136px';
export const SPACING_WIDTH_STICKY_NAV_POPUP = '356px';
export const TYPOGRAPHY_FONT_FAMILY_BRAND = 'Knowledge2017';
export const TYPOGRAPHY_FONT_SIZE_BODY_LARGE_DESKTOP = '19px';
export const TYPOGRAPHY_FONT_SIZE_BODY_LARGE_MOBILE = '16px';
export const TYPOGRAPHY_FONT_SIZE_BODY_LARGE_TABLET = '16px';
export const TYPOGRAPHY_FONT_SIZE_BODY_MEDIUM_DESKTOP = '16px';
export const TYPOGRAPHY_FONT_SIZE_BODY_MEDIUM_MOBILE = '14px';
export const TYPOGRAPHY_FONT_SIZE_BODY_MEDIUM_TABLET = '14px';
export const TYPOGRAPHY_FONT_SIZE_BODY_SMALL_DESKTOP = '14px';
export const TYPOGRAPHY_FONT_SIZE_BODY_SMALL_MOBILE = '12px';
export const TYPOGRAPHY_FONT_SIZE_BODY_SMALL_TABLET = '12px';
export const TYPOGRAPHY_FONT_SIZE_BREADCRUMBS_CURRENT = '12px';
export const TYPOGRAPHY_FONT_SIZE_BREADCRUMBS_LINKS = '12px';
export const TYPOGRAPHY_FONT_SIZE_BUTTON_CIRCULAR = '16px';
export const TYPOGRAPHY_FONT_SIZE_BUTTON_LARGE = '19px';
export const TYPOGRAPHY_FONT_SIZE_BUTTON_MEDIUM = '19px';
export const TYPOGRAPHY_FONT_SIZE_BUTTON_SMALL = '12px';
export const TYPOGRAPHY_FONT_SIZE_DISPLAY_DESKTOP = '56px';
export const TYPOGRAPHY_FONT_SIZE_DISPLAY_MOBILE = '46px';
export const TYPOGRAPHY_FONT_SIZE_DISPLAY_TABLET = '46px';
export const TYPOGRAPHY_FONT_SIZE_EYEBROW_DESKTOP = '14px';
export const TYPOGRAPHY_FONT_SIZE_EYEBROW_MOBILE = '12px';
export const TYPOGRAPHY_FONT_SIZE_EYEBROW_TABLET = '12px';
export const TYPOGRAPHY_FONT_SIZE_FORM_INPUT_TEXT = '16px';
export const TYPOGRAPHY_FONT_SIZE_FORM_LABEL = '14px';
export const TYPOGRAPHY_FONT_SIZE_FORM_MESSAGE = '12px';
export const TYPOGRAPHY_FONT_SIZE_GLOBAL_NAV_LINK_MOBILE = '21px';
export const TYPOGRAPHY_FONT_SIZE_GLOBAL_NAV_LINK_TABLET = '16px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_LARGE_DESKTOP = '40px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_LARGE_MOBILE = '28px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_LARGE_TABLET = '32px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_MEDIUM_DESKTOP = '32px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_MEDIUM_MOBILE = '24px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_MEDIUM_TABLET = '28px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_SMALL_DESKTOP = '28px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_SMALL_MOBILE = '21px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_SMALL_TABLET = '21px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_XLARGE_DESKTOP = '46px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_XLARGE_MOBILE = '36px';
export const TYPOGRAPHY_FONT_SIZE_HEADLINE_XLARGE_TABLET = '40px';
export const TYPOGRAPHY_FONT_SIZE_LINK_DESKTOP = '16px';
export const TYPOGRAPHY_FONT_SIZE_LINK_MOBILE = '14px';
export const TYPOGRAPHY_FONT_SIZE_LINK_TABLET = '14px';
export const TYPOGRAPHY_FONT_SIZE_SUBTITLE_DESKTOP = '21px';
export const TYPOGRAPHY_FONT_SIZE_SUBTITLE_MOBILE = '19px';
export const TYPOGRAPHY_FONT_SIZE_SUBTITLE_TABLET = '19px';
export const TYPOGRAPHY_FONT_SIZE_TABLE_CELL_DESKTOP = '16px';
export const TYPOGRAPHY_FONT_SIZE_TABLE_CELL_MOBILE = '14px';
export const TYPOGRAPHY_FONT_SIZE_TABLE_CELL_TABLET = '14px';
export const TYPOGRAPHY_FONT_SIZE_TABLE_HEADER_DESKTOP = '16px';
export const TYPOGRAPHY_FONT_SIZE_TABLE_HEADER_MOBILE = '14px';
export const TYPOGRAPHY_FONT_SIZE_TABLE_HEADER_TABLET = '14px';
export const TYPOGRAPHY_FONT_SIZE_TAG_DESKTOP = '12px';
export const TYPOGRAPHY_FONT_SIZE_TAG_MOBILE = '12px';
export const TYPOGRAPHY_FONT_SIZE_TAG_TABLET = '12px';
export const TYPOGRAPHY_FONT_WEIGHT_BODY_LARGE = '400';
export const TYPOGRAPHY_FONT_WEIGHT_BODY_MEDIUM = '400';
export const TYPOGRAPHY_FONT_WEIGHT_BODY_SMALL = '400';
export const TYPOGRAPHY_FONT_WEIGHT_BREADCRUMBS_CURRENT = '500';
export const TYPOGRAPHY_FONT_WEIGHT_BREADCRUMBS_LINKS = '400';
export const TYPOGRAPHY_FONT_WEIGHT_BUTTON = '500';
export const TYPOGRAPHY_FONT_WEIGHT_DISPLAY = '300';
export const TYPOGRAPHY_FONT_WEIGHT_EYEBROW = '500';
export const TYPOGRAPHY_FONT_WEIGHT_FORM_INPUT_TEXT = '400';
export const TYPOGRAPHY_FONT_WEIGHT_FORM_LABEL = '500';
export const TYPOGRAPHY_FONT_WEIGHT_FORM_MESSAGE = '500';
export const TYPOGRAPHY_FONT_WEIGHT_GLOBAL_NAV_LINK_ACTIVE_MOBILE = '400';
export const TYPOGRAPHY_FONT_WEIGHT_GLOBAL_NAV_LINK_DEFAULT_MOBILE = '300';
export const TYPOGRAPHY_FONT_WEIGHT_GLOBAL_NAV_LINK_DEFAULT_TABLET = '400';
export const TYPOGRAPHY_FONT_WEIGHT_HEADLINE_LARGE = '300';
export const TYPOGRAPHY_FONT_WEIGHT_HEADLINE_MEDIUM = '300';
export const TYPOGRAPHY_FONT_WEIGHT_HEADLINE_SMALL = '300';
export const TYPOGRAPHY_FONT_WEIGHT_HEADLINE_XLARGE = '300';
export const TYPOGRAPHY_FONT_WEIGHT_LINK = '500';
export const TYPOGRAPHY_FONT_WEIGHT_NAV_OPTION_WITH_ARROW = '500';
export const TYPOGRAPHY_FONT_WEIGHT_SUBTITLE = '400';
export const TYPOGRAPHY_FONT_WEIGHT_TABLE_HEADER = '500';
export const TYPOGRAPHY_FONT_WEIGHT_TAG = '500';
export const TYPOGRAPHY_LETTER_SPACING_HALF_POINT = '0.5px';
export const TYPOGRAPHY_LETTER_SPACING_NEGATIVE_ONE = '-1px';
export const TYPOGRAPHY_LETTER_SPACING_NONE = '0';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_LARGE_DESKTOP = '24px';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_LARGE_MOBILE = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_LARGE_TABLET = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_MEDIUM_DESKTOP = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_MEDIUM_MOBILE = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_MEDIUM_TABLET = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_SMALL_DESKTOP = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_SMALL_MOBILE = '16px';
export const TYPOGRAPHY_LINE_HEIGHT_BODY_SMALL_TABLET = '16px';
export const TYPOGRAPHY_LINE_HEIGHT_BREADCRUMBS_CURRENT = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_BREADCRUMBS_LINKS = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_BUTTON_CIRCULAR = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_BUTTON_LARGE = '24px';
export const TYPOGRAPHY_LINE_HEIGHT_BUTTON_MEDIUM = '24px';
export const TYPOGRAPHY_LINE_HEIGHT_BUTTON_SMALL = '16px';
export const TYPOGRAPHY_LINE_HEIGHT_DISPLAY_DESKTOP = '60px';
export const TYPOGRAPHY_LINE_HEIGHT_DISPLAY_MOBILE = '50px';
export const TYPOGRAPHY_LINE_HEIGHT_DISPLAY_TABLET = '50px';
export const TYPOGRAPHY_LINE_HEIGHT_EYEBROW_DESKTOP = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_EYEBROW_MOBILE = '16px';
export const TYPOGRAPHY_LINE_HEIGHT_EYEBROW_TABLET = '16px';
export const TYPOGRAPHY_LINE_HEIGHT_FORM_INPUT_TEXT = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_FORM_LABEL = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_FORM_MESSAGE = '16px';
export const TYPOGRAPHY_LINE_HEIGHT_GLOBAL_NAV_LINK_MOBILE = '24px';
export const TYPOGRAPHY_LINE_HEIGHT_GLOBAL_NAV_LINK_TABLET = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_LARGE_DESKTOP = '44px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_LARGE_MOBILE = '32px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_LARGE_TABLET = '46px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_MEDIUM_DESKTOP = '46px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_MEDIUM_MOBILE = '30px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_MEDIUM_TABLET = '32px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_SMALL_DESKTOP = '32px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_SMALL_MOBILE = '26px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_SMALL_TABLET = '26px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_XLARGE_DESKTOP = '50px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_XLARGE_MOBILE = '40px';
export const TYPOGRAPHY_LINE_HEIGHT_HEADLINE_XLARGE_TABLET = '44px';
export const TYPOGRAPHY_LINE_HEIGHT_LINK_DESKTOP = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_LINK_MOBILE = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_LINK_TABLET = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_SUBTITLE_DESKTOP = '26px';
export const TYPOGRAPHY_LINE_HEIGHT_SUBTITLE_MOBILE = '24px';
export const TYPOGRAPHY_LINE_HEIGHT_SUBTITLE_TABLET = '24px';
export const TYPOGRAPHY_LINE_HEIGHT_TABLE_CELL_DESKTOP = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_TABLE_CELL_MOBILE = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_TABLE_CELL_TABLET = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_TABLE_HEADER_DESKTOP = '20px';
export const TYPOGRAPHY_LINE_HEIGHT_TABLE_HEADER_MOBILE = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_TABLE_HEADER_TABLET = '18px';
export const TYPOGRAPHY_LINE_HEIGHT_TAG_DESKTOP = '16px';
export const TYPOGRAPHY_LINE_HEIGHT_TAG_MOBILE = '16px';
export const TYPOGRAPHY_LINE_HEIGHT_TAG_TABLET = '16px';
export const TYPOGRAPHY_TEXT_DECORATION_BUTTON_HIGHLIGHT = 'underline';
export const TYPOGRAPHY_TEXT_TRANSFORM_LINK = 'underline';
export const VERSION_CLI = '0.1.0';
export const VERSION_FIGMA = '1890740489';
